import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "kno2-top-pane",
    template: "<ng-content></ng-content>",
    styleUrls: ["./top-pane.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class TopPaneComponent {}
